<template>
  <div class="leaflet-page">
    <img src="//download-cos.yofish.com/jz-gongjushiyebu/20220106152501913-bg.jpg"
      width="100%" alt="">
    <div class="submit-btn" @click="applyAction">
      <img src="~@/assets/images/leaflet/appy-btn.png" width="100%" alt="">
    </div>
    <y-dialog :visible="visible">
      <div class="head">
        <img src="~@/assets/images/leaflet/frame.png" alt="" width="100%">
      </div>
      <div class="apply-content">
        <div class="input">
          <input type="text" placeholder="请输入手机号码" v-model="phoneNumber" />
        </div>
      </div>
      <div class="apply-btn" @click="submitAction">
        <img src="~@/assets/images/leaflet/submit-btn.png" width="100%" alt="">
      </div>
      <div class="check-module">
        <div class="image" @click="isChecked = !isChecked">
          <img :src="imgUrl" alt="" />
        </div>
        <span>我同意以下协议</span>
      </div>
      <div class="agreement-content">
        <y-agreement />
      </div>
    </y-dialog>
  </div>
</template>
<script>
import { getPublicize, getUploadClickAction } from '@/api/base';
import { getAppStatus, callAppHandler } from '@/utils/app';
import YDialog from '@/components/dialog';
import YAgreement from '@/components/agreement';
import { checkPhone } from '@/utils';

export default {
  name: 'SpdbPoster',
  components: { YDialog, YAgreement },
  data() {
    return {
      visible: false,
      phoneNumber: '',
      userId: getAppStatus().cuserId,
      isChecked: true,
    };
  },
  watch: {
    visible(val) {
      if (!val) this.phoneNumber = '';
    },
  },
  mounted() {
    document.title = '浦发银行宣传页';
    this.userId = this.userId || sessionStorage.getItem('userId');
    // this.getPublicize();
  },
  computed: {
    phone() {
      return getAppStatus().phone;
    },
    userIds() {
      // "6bbf384d-dacd-472e-8c9f-d013c59d20b9"
      return getAppStatus().cuserId;
      // return '6bbf384d-dacd-472e-8c9f-d013c59d20b9';
    },
    imgUrl() {
      const { isChecked } = this;
      return !isChecked ? require('@/assets/images/leaflet/no-checked.png')
        : require('@/assets/images/leaflet/checked.png');
    },
  },
  methods: {
    async getPublicize() {
      let res;
      let data = { paramV: 'dddd' };
      const { query } = this.$route;
      // data = JSON.stringify(data);
      try {
        res = await getPublicize(query);
      } catch (e) {
        console.log(e);
        this.$toast({
          content: e.desc,
        });
      }
      if (res.code === 1) {
        this.linkUrl = res?.results?.linkUrl;
        this.channel = res?.results?.channel;
      }
    },
    async getUploadClickAction() {
      let res;
      let shortData = sessionStorage.getItem('shortData');
      shortData = JSON.parse(shortData || '{}');
      let { linkUrl, channel, jumpLevel } = shortData;
      const { host } = window.location;
      const {
        phoneNumber, userId, phone,
      } = this;
      const params = {
        phone: phoneNumber,
        channel,
      };
      if (userId && !phone) sessionStorage.setItem('userId', userId);
      try {
        res = await getUploadClickAction(params);
      } catch (e) {
        console.log(e);
        this.visible = false;
        window.location.replace(`//${host}/bank/404`);
      }
      this.visible = false;
      let timestamp = new Date().getTime() / 1000;
      timestamp = Math.floor(timestamp);
      let fromPath = this.$route.path;
      if (res.code === 1 && linkUrl) {
        if (jumpLevel > 1) {
          this.$router.push({
            path: `/leaflet/jump${jumpLevel - 1}`,
            query: {
              timestamp,
              fromPath,
            },
          });
        } else {
          window.location.replace(linkUrl);
        }
      } else {
        window.location.replace(`//${host}/bank/404`);
      }
    },
    applyAction() {
      if (!this.phone) {
        this.visible = true;
      } else {
        this.phoneNumber = this.phone;
        this.getUploadClickAction();
      }
    },
    submitAction() {
      const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
      if (!this.phoneNumber) {
        this.$toast({ content: '请填写手机号!', duration: 2000 });
      } else if (!checkPhone(this.phoneNumber)) {
        this.$toast({ content: '手机号填写有误,请重新输入!', duration: 2000 });
      } else if (!this.isChecked) {
        this.$toast({ content: '请阅读并勾选用户协议', duration: 2000 });
      } else {
        window?._czc?.push(['_trackEvent', '浦发银行', '点击', '申请手机号']);
        this.getUploadClickAction();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.leaflet-page {
  width: 100%;
  // overflow: hidden;
  position: relative;
  .head {
    width: 236px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -90px;
    z-index: 30;
  }
  .submit-btn {
    width: 690px;
    height: 110px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 59px;
  }
}
.apply-content {
  padding: 165px 49px 0 49px;
  .input {
    position: relative;
    width: 100%;
    height: 60px;
    // border-bottom: 2px solid #E5E4E4;
    input {
      border-bottom: 2px solid #E5E4E4;
    }
  }
  input {
    width: 100%;
    height: 55px;
    border: none;
    font-size: 28px;
    &::-webkit-input-placeholder {
      font-size: 28px;
      color: #CDCDCD;
    }
  }
}
.apply-btn {
  width: 538px;
  height: 79px;
  border: 2px solid #FFFFFF;
  border-radius: 40px;
  line-height: 79px;
  text-align: center;
  font-size: 47px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-style: italic;
  color: #FFFFFF;
  text-shadow: 0px 4px 5px rgba(13, 127, 134, 0.56);
  margin: 45px auto 0;
}
.agreement-content {
  // width: 576px;
  height: 204px;
  background: #F9F9F9;
  border-radius: 8px;
  overflow-y: auto;
  margin: 40px 25px;
  padding: 20px;
}
.check-module {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  align-items: center;
  > .image {
    width: 24px;
    margin-right: 10px;
    flex: 0 0 auto;
    position: relative;
    top: 3px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  span {
    font-size: 24px;
    color: #505050;
  }
}
/deep/ .y-dialog-main {
  height: auto;
}
</style>
